import { createReducer, on } from "@ngrx/store";
import { Settings } from "src/model/class/settings";
import {
  serverSettingsLoadCompleteAction,
  serverSettingsUnsetKeyStorageAction,
  serverSettingsUpdateShowStatusBarAction,
} from "../actions/server-settings.action";

/**
 * Reducer for server settings
 */
export const ServerSettingsReducer = createReducer(
  null,
  on(serverSettingsUnsetKeyStorageAction, (serverSetting: Settings, action) => {
    return null;
  }),
  on(serverSettingsLoadCompleteAction, (serverSetting: Settings, action) => {
    return action.serverSettings;
  }),
  on(
    serverSettingsUpdateShowStatusBarAction,
    (serverSetting: Settings, action) => {
      const updateServerSetting: Settings = new Settings({
        ...serverSetting,
        ShowStatusBar: action.showStatusbar,
      });

      return updateServerSetting;
    }
  )
);
